import { getTimeslotByHours, selectTimeslotsMap, TimeslotMapItem } from "entities/toolbar/timeslots";
import { useState } from "react";
import { useAppSelector } from "shared/lib/store";
import { minutesToTime } from "shared/lib/time";
import { Option } from "shared/types";

export const useBookingDuration = () => {
    const timeslotsMap = useAppSelector(selectTimeslotsMap);

    const [durationOption, setDurationOption] = useState<Option | null>(null);

    const getCurrentTimeSlot = (timeString: string) => {
      return getTimeslotByHours(timeslotsMap, timeString.substring(0, 2));
    }

    const getBaseDuration = (timeString: string, timeslots?: false | TimeslotMapItem[]) => {
      if (!timeslots) timeslots = getCurrentTimeSlot(timeString);

      if (!timeslots) return 0;

      return timeslots.find(slot => slot.time === timeString)?.base_duration || 0;
    }

    const getMinDuration = (timeString: string, timeslots?: false | TimeslotMapItem[]) => {
      if (!timeslots) timeslots = getCurrentTimeSlot(timeString);

      if (!timeslots) return 0;

      return timeslots.find(slot => slot.time === timeString)?.min_duration || 0;
    }

    const setDurationByTime = (timeString: string) => {
      const timeslots = getCurrentTimeSlot(timeString);

      if (timeslots) {
        const duration = getBaseDuration(timeString, timeslots)

        const durationString = minutesToTime(duration || 0);

        setDurationOption({ label: durationString, value: durationString})

        return { label: durationString, value: durationString};
      }
    }

    return {
        durationOption,
        setDurationOption,
        setDurationByTime,
        getCurrentTimeSlot,
        getBaseDuration,
        getMinDuration
    }
}